<div class="row">
  <div class="col-12 col-lg-12">

    <!-- Card -->
    <div class="card card-fill">
      <div class="card-header">

        <!-- Title -->
        <h4 class="card-header-title">
          Activités récentes
        </h4>

      </div>
      <div class="card-body">

        <!-- List group -->
        <div class="list-group list-group-flush list-group-activity my-n3">
          @for (event of timelineEvents; track event) {
            <div class="list-group-item">
              <app-timeline-calculation-run-event [event]="event"></app-timeline-calculation-run-event>
            </div>
          }
        </div>

        @if (this.displayEmptyState) {
          <div class="text-center">
            <img class="mt-5 mb-5" src="../../../assets/images/brain.svg" style="width: 50px;"/>
            <p><strong>Vous ou aucuns de vos collègues n’ont encore effectué de calculs.</strong></p>
            <a class="btn btn-lg btn-primary mt-3" routerLink="/calculations/create">Créer votre premier
            calcul</a>
          </div>
        }
      </div>
    </div>

  </div>
</div>